<template>
  <section class="cta">
    <base-container>
      <el-row justify="space-around">
        <el-col :sm="24" :lg="11">
          <!-- <el-buttton class="cta-button">Send</el-buttton> -->
          <div class="container">
            <img
              src="../../assets/bottom-cta-button@2x.png"
              style="width: 380px"
              alt=""
            />
            <p class="centered">加入會員</p>
          </div>
        </el-col>
        <el-col :sm="24" :lg="11">
          <!-- <el-buttton class="cta-button">Send</el-buttton> -->
          <div class="container">
            <img
              src="../../assets/bottom-cta-button@2x.png"
              style="width: 380px"
              alt=""
            />
            <p class="centered">會員優惠</p>
          </div>
        </el-col>
      </el-row>
    </base-container>
  </section>
</template>



<style scoped>
.cta {
  background-image: url("../../assets/img-bottombg@2x.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 990px;
  /* padding: 2rem 0; */
  /* margin-bottom: 2rem; */
  /* max-width: 1920px; */
}

.container {
  position: relative;
  text-align: center;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 28px;
  font-weight: 700;
}

.cta .el-col {
  /* padding-left: 1.5rem; */
}

.cta .el-col:last-of-type {
  /* padding-right: 1.5rem; */
}

.cta-img:last-of-type {
  /* margin-right: 3rem; */
}
.cta-button {
  background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    #f9dc5c;
  box-shadow: 0px 0.5px 0px rgba(0, 0, 0, 0.4), 0px 2px 2px rgba(0, 0, 0, 0.3),
    0px 8px 12px rgba(0, 0, 0, 0.15), inset 0px -8px 4px rgba(206, 168, 0, 0.8),
    inset 0px -14px 8px #fff1b4;
  border-radius: 12px;
  padding: 1.8rem 8rem;
  /* display: inline-flex;
  justify-content: center;
  align-items: center; */
}
</style>